import React, {useState} from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {useTranslate} from 'ra-core';

export default ({options = [], label = null}) => {
  const translate = useTranslate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = !!anchorEl;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button onClick={handleClick}>
        <MoreVertIcon />
        {label && <label>{translate(label)}</label>}
      </Button>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        {options.map(o => (
          <MenuItem key={o.key || index} onClick={handleClose}>
            {o}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
